import { Component, input } from '@angular/core';
import { TooltipDirective } from './tooltip.directive';


@Component({
    selector: 'info-icon',
    imports: [
        TooltipDirective,
    ],
    styles: [
        `
        :focus-visible {
            outline: 1px dotted;
            outline: 5px auto -webkit-focus-ring-color;
        }
        `
    ],
    template: `
        <i
            class="fa fa-question-circle"
            tabindex="0"
            [tooltip]="text()"
            [tooltipPlacement]="placement()">
        </i>
    `,
})
export class InfoIconComponent {

    text = input.required<string>();

    placement = input<'top' | 'bottom' | 'left' | 'right'>('top');
}
